 const API_ENDPOINT='https://apidisplay.infa-formation.com';



 export default API_ENDPOINT;
